import React, { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom'
import Dashboard from './components/Dashboard'
import Lessons from './components/Lessons'
import Login from './components/Login'
import { isAuthenticated, getUserInfo, logout } from './services/auth'
import './App.css'

function AppContent() {
  const [authenticated, setAuthenticated] = useState(false)
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState(null)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    checkAuth()
  }, [])

  const checkAuth = async () => {
    try {
      const authStatus = await isAuthenticated()
      setAuthenticated(authStatus)

      if (authStatus) {
        const userInfo = await getUserInfo()
        setUser(userInfo)
      }
    } catch (error) {
      console.error('Auth check error:', error)
      setAuthenticated(false)
    } finally {
      setLoading(false)
    }
  }

  const handleLogout = () => {
    logout()
  }

  if (loading) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    )
  }

  if (!authenticated) {
    const currentPath = window.location.pathname
    const getReturnUrl = () => {
      if (currentPath === '/' || currentPath === '/login') {
        return '/dashboard'
      }
      return currentPath
    }

    return (
      <div className="app">
        <div className="app-content">
          <Routes>
            <Route path="/login" element={<Login returnUrl={getReturnUrl()} />} />
            <Route path="*" element={<Login returnUrl={getReturnUrl()} />} />
          </Routes>
        </div>
      </div>
    )
  }

  return (
    <div className="app">
      <div className="app-header">
        <div className="app-header-brand">
          <img src="/logo.png" alt="Ditto Logo" className="app-logo" />
          <h1>Ditto Training System</h1>
        </div>
        <nav className="app-nav">
          <button
            onClick={() => navigate('/dashboard')}
            className={location.pathname === '/dashboard' ? 'active' : ''}
          >
            Logging
          </button>
          <button
            onClick={() => navigate('/lessons')}
            className={location.pathname === '/lessons' ? 'active' : ''}
          >
            Lessons
          </button>
        </nav>
        <div className="app-user">
          {user && (
            <span className="user-name">{user.name || user.email}</span>
          )}
          <button className="logout-button" onClick={handleLogout}>
            Sign Out
          </button>
        </div>
      </div>

      <div className="app-content">
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/lessons" element={<Lessons />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  )
}

export default App
